import styled from "styled-components/macro";

export const TableRowButtonBox = styled.div`
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
